/**
 * Helper functions for handling images with proper fallbacks
 */

import { getUniversityCampusUrl, getUniversityLogoUrl, getCountryFlagUrl, getCountryHeroUrl } from './supabase-storage'
import { UNIVERSITIES, FLAGS, DESTINATIONS } from '@/constants/images'

// Check if running in browser environment
const isBrowser = typeof window !== 'undefined'

/**
 * Get university logo URL with proper fallback handling
 */
export function getUniversityLogo(slug: string): string {
  // Always prefer local files in development
  if (process.env.NODE_ENV === 'development') {
    return `${UNIVERSITIES.LOGOS}/${slug}.webp`
  }
  
  // In production, use Supabase
  try {
    return getUniversityLogoUrl(slug)
  } catch (error) {
    // If Supabase fails, fall back to GCS
    return `${UNIVERSITIES.LOGOS}/${slug}.webp`
  }
}

/**
 * Get university campus image URL with proper fallback handling
 */
export function getUniversityCampus(slug: string): string {
  // Always prefer local files in development
  if (process.env.NODE_ENV === 'development') {
    return `${UNIVERSITIES.CAMPUS}/${slug}.webp`
  }
  
  // In production, use Supabase
  try {
    return getUniversityCampusUrl(slug)
  } catch (error) {
    // If Supabase fails, fall back to GCS
    return `${UNIVERSITIES.CAMPUS}/${slug}.webp`
  }
}

/**
 * Get country flag URL with proper fallback handling
 */
export function getCountryFlag(code: string): string {
  // Always prefer local files in development
  if (process.env.NODE_ENV === 'development') {
    return `${FLAGS.BASE}/${code.toLowerCase()}.svg`
  }
  
  // In production, use Supabase
  try {
    return getCountryFlagUrl(code)
  } catch (error) {
    // If Supabase fails, fall back to GCS
    return `${FLAGS.BASE}/${code.toLowerCase()}.svg`
  }
}

/**
 * Get country hero image URL with proper fallback handling
 */
export function getCountryHero(slug: string): string {
  // Always use GCS for country hero images
  const upperSlug = slug.toUpperCase()
  if (upperSlug in DESTINATIONS) {
    return `${DESTINATIONS[upperSlug as keyof typeof DESTINATIONS]}.webp`
  }
  return `${DESTINATIONS.DEFAULT}.webp`
} 